var map = {
	"./index.js": 81,
	"./messages.js": 312,
	"./notifications.js": 313,
	"./products.js": 314,
	"./tasks.js": 315,
	"./user.js": 316
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 878;


//////////////////
// WEBPACK FOOTER
// ./src/vuex/modules nonrecursive \.js$
// module id = 878
// module chunks = 0